import { useTranslation } from 'react-i18next';

import { DateVehicleEmptyActions } from '@/shared/ui/no-result-display/DateVehicleEmptyActions';
import DisplayNoResult from '@/shared/ui/no-result-display/DisplayNoResult';

export function RefuelsNoResult({
  onChooseNewDate,
  onChooseNewVehicle,
}: {
  onChooseNewDate?: () => void;
  onChooseNewVehicle?: () => void;
}) {
  const { t } = useTranslation();

  return (
    <DisplayNoResult message={t('refuels.noResult.noResultDateInterval')}>
      {onChooseNewDate && onChooseNewVehicle && (
        <DateVehicleEmptyActions
          onChooseNewDate={onChooseNewDate}
          onChooseNewVehicle={onChooseNewVehicle}
          newDateLabel={t('general.setNewDate')}
          newVehicleLabel={t('general.setNewVehicle')}
        />
      )}
    </DisplayNoResult>
  );
}
